import React from 'react';

import { useUserDetails } from 'api/useUserDetails';

import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';

import ProfileDropDown from './ProfileDropDown/ProfileDropDown';

export const Header: React.FC = () => {
  const { userDetails } = useUserDetails();

  return (
    <header className="sticky top-0 bg-white mt-2.5 mb-4 mx-7 flex items-center z-50">
      <Breadcrumbs />
      <div className="flex-1 flex justify-end">
        <ProfileDropDown user={userDetails} />
      </div>
    </header>
  );
};
